module.exports = {
    Debug: function (namespace) {
        return {
            error: function () {
                console.debug(namespace, arguments);
            },
            info: function () {
                console.debug(namespace, arguments);
            },
        };
    },
};
